/**
 * Guarded map teardown (V.20).
 *
 * Terra Draw's control adds and removes GeoJSON sources on the map. If the map is torn down
 * while its style is reloading (e.g. just after a theme toggle) the sources are gone and
 * `clear()` throws "Cannot read properties of undefined (reading 'setData')", which then
 * aborts `Map.remove()` and leaves the app blank. Remove our controls first, one by one,
 * and never let a failure escape.
 */

/** Remove a control from a MapLibre map without throwing. Returns true if it detached cleanly. */
export function safeRemoveControl(map, control) {
  if (!map || !control) return false;
  try {
    let styleReady = true;
    try { styleReady = typeof map.isStyleLoaded === 'function' ? !!map.isStyleLoaded() : true; } catch { styleReady = false; }
    if (!styleReady) {
      // Terra Draw can only be cleared while the style (and its sources) exist: stop it first.
      try {
        const draw = typeof control.getTerraDrawInstance === 'function' ? control.getTerraDrawInstance() : null;
        if (draw && typeof draw.stop === 'function') draw.stop();
      } catch { /* sources already gone */ }
    }
    map.removeControl(control);
    return true;
  } catch {
    // onRemove threw half way: drop the control from the map's own list so Map.remove() does
    // not call the broken onRemove a second time.
    try {
      if (Array.isArray(map._controls)) map._controls = map._controls.filter((c) => c !== control);
    } catch { /* ignore */ }
    return false;
  }
}
